import React, { Component } from 'react';

class IconQueue extends Component {
    render() {
        return (
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.4875 0C5.5875 0 0 5.6 0 12.5C0 19.4 5.5875 25 12.4875 25C19.4 25 25 19.4 25 12.5C25 5.6 19.4 0 12.4875 0ZM17.5 17.5C17.3844 17.6159 17.247 17.7078 17.0958 17.7705C16.9446 17.8333 16.7825 17.8656 16.6187 17.8656C16.455 17.8656 16.2929 17.8333 16.1417 17.7705C15.9905 17.7078 15.8531 17.6159 15.7375 17.5L11.625 13.3875C11.5069 13.2717 11.4129 13.1337 11.3486 12.9813C11.2842 12.829 11.2507 12.6654 11.25 12.5V7.5C11.25 6.8125 11.8125 6.25 12.5 6.25C13.1875 6.25 13.75 6.8125 13.75 7.5V11.9875L17.5 15.7375C17.9875 16.225 17.9875 17.0125 17.5 17.5Z" fill="#1D53A5" />
            </svg>
        );
    }
}

export default IconQueue;